import { QUOTA_CONFIG } from '../utils/constants';
import { QuotaStats } from '../types';

export class QuotaManager {
  public requestCount: number = 0;
  public requestHistory: number[] = [];
  private baseDelayMs: number = QUOTA_CONFIG.BASE_DELAY;
  public currentDelayMs: number = QUOTA_CONFIG.BASE_DELAY;
  private maxQPS: number = QUOTA_CONFIG.MAX_QPS;
  public quotaExceeded: boolean = false;
  public consecutiveErrors: number = 0;

  async waitForSlot(): Promise<void> {
    const now = Date.now();

    this.requestHistory = this.requestHistory.filter(time => now - time < 1000);

    if (this.requestHistory.length >= this.maxQPS || this.quotaExceeded) {
      console.log(`等待 ${this.currentDelayMs}ms...`);
      await new Promise<void>(resolve => setTimeout(resolve, this.currentDelayMs));
    }

    this.requestHistory.push(now);
    this.requestCount++;
  }

  handleQuotaError(): void {
    console.log('遇到配额超限错误，增加延迟');
    this.quotaExceeded = true;
    this.consecutiveErrors++;
    this.currentDelayMs = Math.min(
      QUOTA_CONFIG.BASE_DELAY * Math.pow(2, this.consecutiveErrors),
      QUOTA_CONFIG.MAX_DELAY
    );
    console.log(`当前延迟: ${this.currentDelayMs}ms`);
  }

  handleSuccess(): void {
    if (this.quotaExceeded) {
      console.log('请求成功，重置错误计数');
      this.consecutiveErrors = Math.max(0, this.consecutiveErrors - 1);

      if (this.consecutiveErrors === 0) {
        this.quotaExceeded = false;
        this.currentDelayMs = this.baseDelayMs;
        console.log('配额限制已解除');
      } else {
        this.currentDelayMs = Math.min(
          QUOTA_CONFIG.BASE_DELAY * Math.pow(2, this.consecutiveErrors),
          QUOTA_CONFIG.MAX_DELAY
        );
      }
    }
  }

  getStats(): QuotaStats {
    return {
      requestCount: this.requestCount,
      currentDelayMs: this.currentDelayMs,
      quotaExceeded: this.quotaExceeded,
      consecutiveErrors: this.consecutiveErrors
    };
  }

  reset(): void {
    this.requestCount = 0;
    this.requestHistory = [];
    this.currentDelayMs = this.baseDelayMs;
    this.quotaExceeded = false;
    this.consecutiveErrors = 0;
    console.log('配额管理器已重置');
  }
}
